import gql from 'graphql-tag'

export const getAccountAsset = gql`
  query($accountAssetId: Int!) {
    getAccountAsset(
      accountAssetId: $accountAssetId
    ) {
      id
      name
      notes
      type
      createdAt
      updatedAt
      account {
        id
        name
      }
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
      files {
        id
        type
        name
        size
        createdAt
        updatedAt
      }
      property {
        id
        address1
        address2
        city
        state
        country
        zipCode
        propertyType
        owner
        price
        propertyStatus
        creationTime
        buyTime
        createdAt
        updatedAt
      }
      vehicle {
        id
        vid
        owner
        brand
        color
        type
        price
        createdAt
        updatedAt
      }
    }
  }
`

export const newAssetProperty = gql`
  mutation($input: AssetPropertyInput!, $accountId: Int!) {
    newAssetProperty(
      accountId: $accountId,
      input: $input
    ) {
      id
    }
  }
`

export const editAssetProperty = gql`
  mutation($accountAssetId: Int!, $input: AssetPropertyInput!) {
    editAssetProperty(
      accountAssetId: $accountAssetId,
      input: $input
    ) {
      id
    }
  }
`

export const newAssetVehicle = gql`
  mutation($input: AssetVehicleInput!, $accountId: Int!) {
    newAssetVehicle(
      accountId: $accountId,
      input: $input
    ) {
      id
    }
  }
`

export const editAssetVehicle = gql`
  mutation($accountAssetId: Int!, $input: AssetVehicleInput!) {
    editAssetVehicle(
      accountAssetId: $accountAssetId,
      input: $input
    ) {
      id
    }
  }
`

export const deleteAccountAsset = gql`
  mutation($accountAssetId: Int!) {
    deleteAccountAsset(
      accountAssetId: $accountAssetId
    )
  }
`
